const ROUTER_FUTURE_FLAGS = {
  v7_relativeSplatPath: true,
  v7_startTransition: true
};

export default ROUTER_FUTURE_FLAGS;
